/**
 * External dependencies
 */
import { get } from 'lodash';

export const getPaymentTypeId = state => get(state, 'ui.paymentTypesModal.paymentTypeId', "");